const title = {
  signin: 'Đăng nhập',
  signup: 'Đăng ký',
  forgotPassword: 'Quên mật khẩu',
  allCategories: 'Tất cả danh mục',
  profile: 'Trang cá nhân',
  registerBusiness: 'Đăng ký doanh nghiệp',
  Home: 'Trang chủ',
  SearchProductPage : 'Tìm kiếm sản phẩm',
  ListDemandPage : 'Nhu cầu',
  AllCategories : 'Danh mục',
  NewsCategoryPage : 'Tin tức',
  FAQPage : 'Các câu hỏi thường gặp',
  ContactPage : 'Liên hệ',
  FeedbackPage : 'Phản hồi',
  CategoryDetailPage: 'Chi tiết danh mục sản phẩm',
  ListCategoryPage: 'Danh mục sản phẩm',
  ListProductPage: 'Sản phẩm',
  NewsDetailPage: 'Tin tức chi tiết',
  ProductDetailPage: 'Chi tiết sản phẩm',
  // User

  Dashboard : 'Bảng tin',
  SendNeedoffer : 'Gửi nhu cầu',
  Announcement : 'Thông báo',
  AnnouncementDetail : 'Chi tiết thông báo',
  Profile : 'Thông tin cá nhân',
  ChangePassword : 'Thay đổi mật khẩu',
  Complaint : 'Khiếu nại',
  SendComplaint : 'Gửi khiếu nại',
  ComplaintDetail : 'Chi tiết khiếu nại',
  FavoriteProduct : 'Sản phẩm / Dịch vụ yêu thích',
  MyDemand : 'Nhu cầu đã đăng',
  MyDemandDetailPage : 'Chi tiết nhu cầu',
  PostDemandPage : 'Gửi nhu cầu',
  MyRequests : 'Yêu cầu đã gửi',
  RequestDetail : 'Chi tiết yêu cầu',
  MyShoppingCartPage : 'Giỏ hàng',
  OrderHistory : 'Lịch sử giao dịch',
  OrderHistoryDetail : 'Chi tiết lịch sử giao dịch',

  //Business
  BusinessPage: 'Trang doanh nghiệp',
  KontunmBusinessPage: 'Doanh nghiệp Kontum',
  MyBusinessPage : 'Bảng tin doanh nghiệp',
  MyBusinessAnnouncementPage : 'Thông báo',
  MyBusinessAnnouncementDetailPage : 'Chi tiết thông báo',
  MyBusinessPaymentsPage : 'Thông tin thanh toán',
  MyBusinessProfilePage : 'Thông tin doanh nghiệp',
  MyBusinessAddProductPage : 'Thêm sản phẩm mới',
  MyBusinessAddFairProductPage : 'Thêm mới phẩm hội chợ triễn lãm',
  MyBusinessManageProductPage : 'Quản lý sản phẩm',
  MyBusinessEditProductPage : 'Chỉnh sửa sản phẩm',
  MyBusinessListFairProductPage : 'Quản lý sản phẩm hội chợ triễn lãm',
  MyBusinessStatsPage : 'Thống kê',
  MyBusinessManageOrderPage : 'Quản lý đơn hàng',
  MyBusinessManageOrderDetailPage : 'Chi tiết đơn hàng',
  MybusinessNeedOfferPage : 'Quản lý nhu cầu',
  MybusinessNeedOfferDetailPage : 'Chi tiết nhu cầu',
  NeedOfferDetailPage : 'Chi tiết nhu cầu',
  MyBusinessPostDemandPage : 'Gửi nhu cầu',
  MyBusinessFairPage : 'Hội chợ triễn lãm',
  MyBusinessRequests : 'Danh sách gửi yêu cầu của doanh nghiệp',

  ThankPage : 'Cảm ơn',
  RestorePasswordPage : 'Thay đổi mật khẩu',
  FairDashBoardPage : 'Hội chợ',
  PageNotFound : 'Không tìm thấy trang này'

};

export default title;



// WEBPACK FOOTER //
// ./constants/TitlePages.js